export default __webpack_public_path__ + "static/media/1280x500_hami.38c02124.jpg";